
function initBuffers(gl, res = 1, gap = 0.01, amp = -0.003, bg= true, sides, averages = null) {

  var init_offs = 0.0;

  /*
  var amp = 0.001;
  var init_offs = -0.2;
  */

  var l = 0.2;
  var r = 0.8;
  var t = 0.8;
  var b = 0.2;

  var faces = res*res;
  //var faces = res*res*res;


  function rand(){
    return (Math.random()*2-1);
  }
  var possible_indices = [];
  for(var i = 0; i<faces*4; i++){
    possible_indices.push(i);
  }

  function shuffle(nums){
    for (var i = nums.length-1; i > 0; i--){
      var j = Math.floor(Math.random()*(i+1));
      const temp = nums[i];
      nums[i] = nums[j];
      nums[j] = temp;
    }
    return nums;
  }

  const positions= [];
  const vertexNormals = [];
  const textureCoordinates = [];
  const indices = [];

  /*for(var i = 0; i < faces; i++){
    for(var v = 0; v < 4; v++) {
      positions.push(rand());
      positions.push(rand());
      positions.push(rand());
    }
    vertexNormals.push(0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0);
    textureCoordinates.push(l, b, r, b, r, t, l, t);

    possible_indices = shuffle(possible_indices);
    indices.push(
        possible_indices[0],
        possible_indices[1],
        possible_indices[2],
        possible_indices[3],
        possible_indices[4],
        possible_indices[5]
    );
  }*/

  var quadsize = 2 / res;  //from -1 to 1
  var origin = { x : (-1 - res*gap/2), y: (-1 - res*gap/2) };
  var origin2 = {
    x : (-1 - gap*res/2),
    y : (-1 - gap*res/2),
    z : (-1 - gap*res/2)
  }

  var texQuadsize = (r-l) / res;
  var texOrigin = { x : l, y: b }



  function getTexCoords(x, y){

    var pixelorigin = {
      x: texOrigin.x + (x * texQuadsize) + (texQuadsize / 2),
      y: texOrigin.y + (y * texQuadsize) + (texQuadsize / 2),
    }

    return {
      l : pixelorigin.x - texQuadsize/2,
      b : pixelorigin.y - texQuadsize/2,
      r : pixelorigin.x + texQuadsize/2,
      t : pixelorigin.y + texQuadsize/2,
    }
  }



  /*
  function getTexCoords(x, y){
    return {
      l : l,
      b : b,
      r : r,
      t : t,
    }
  }
  */

  function getCoords(x, y){

    var pixelorigin = {
      x: origin.x + x * (quadsize+gap) + (quadsize / 2) + gap/2,
      y: origin.y + y * (quadsize+gap) + (quadsize / 2) + gap/2,
    }

    return {
      x1 : pixelorigin.x - quadsize/2, y1 : pixelorigin.y - quadsize/2,
      x2 : pixelorigin.x + quadsize/2, y2 : pixelorigin.y - quadsize/2,
      x3 : pixelorigin.x + quadsize/2, y3 : pixelorigin.y + quadsize/2,
      x4 : pixelorigin.x - quadsize/2, y4 : pixelorigin.y + quadsize/2,
    }
  }

  function getVoxelCenter(i, j, k){
    return {
      x: origin2.x + i * (quadsize+gap) + (quadsize / 2) + gap/2,
      y: origin2.y + j * (quadsize+gap) + (quadsize / 2) + gap/2,
      z: origin2.z + k * (quadsize+gap) + (quadsize / 2) + gap/2,
    }
  }



  var texels= [];
  for(var i = 0; i<faces; i++){
    texels.push(i);
  }
  //texels = shuffle(texels);

  /*
  for(var s = 0; s<sides; s++) {
    for (var a = 0; a < faces; a++) {
      var tex_i = texels[a] % res;
      var tex_j = Math.floor(texels[a] / res);
      var textxy = getTexCoords(tex_i, tex_j);

      textureCoordinates.push(
          textxy.l, textxy.b,
          textxy.r, textxy.b,
          textxy.r, textxy.t,
          textxy.l, textxy.t,
      );
    }
  }*/

  for(var s = 0; s<sides; s++) {
    for (var a = 0; a < faces; a++) {
      var tex_i = texels[a] % res;
      var tex_j = Math.floor(texels[a] / res);
      var textxy = getTexCoords(tex_i, tex_j);

      textureCoordinates.push(
          textxy.l, textxy.b,
          textxy.r, textxy.b,
          textxy.r, textxy.t,
          textxy.l, textxy.t,
      );
    }
  }

  textureCoordinates.push(
      l, b,
      r, b,
      r, t,
      l, t,
  );

  var z =  (res * quadsize / 2) + (gap/2 * (res-1)) ;
  function generatePositions(side, i, j){
    var offs = init_offs;
    if(averages != null){
      offs += averages[j*(res)+i].avgR * amp;
      offs += averages[j*(res)+i].avgG * amp;
      offs += averages[j*(res)+i].avgB * amp;
    }

    var xy = getCoords(i, j);
    if(side===0){ positions.push(xy.x1, xy.y1, (z+offs), xy.x2, xy.y2, (z+offs), xy.x3, xy.y3, (z+offs), xy.x4, xy.y4, (z+offs)); }
    if(side===1){ positions.push(xy.x1, (z+offs), xy.y1, xy.x2, (z+offs), xy.y2, xy.x3, (z+offs), xy.y3, xy.x4, (z+offs), xy.y4); }
    if(side===2){ positions.push((z+offs), xy.x1, xy.y1, (z+offs), xy.x2, xy.y2, (z+offs), xy.x3, xy.y3, (z+offs), xy.x4, xy.y4); }
    if(side===3){ positions.push(xy.x1, xy.y1, -(z+offs), xy.x2, xy.y2, -(z+offs), xy.x3, xy.y3, -(z+offs), xy.x4, xy.y4, -(z+offs)); }
    if(side===4){ positions.push(xy.x1, -(z+offs), xy.y1, xy.x2, -(z+offs), xy.y2, xy.x3, -(z+offs), xy.y3, xy.x4, -(z+offs), xy.y4); }
    if(side===5){ positions.push(-(z+offs), xy.x1, xy.y1, -(z+offs), xy.x2, xy.y2, -(z+offs), xy.x3, xy.y3, -(z+offs), xy.x4, xy.y4); }
  }

  function generateNormals(side){
    if(side===0){ vertexNormals.push(0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0); }
    if(side===1){ vertexNormals.push(0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0); }
    if(side===2){ vertexNormals.push(1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0); }
    if(side===3){ vertexNormals.push(0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0); }
    if(side===4){ vertexNormals.push(0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0); }
    if(side===5){ vertexNormals.push(-1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0); }
  }

  function generateVoxelNormals(){
    vertexNormals.push(0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0);
    vertexNormals.push(0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0);
    vertexNormals.push(1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    vertexNormals.push(0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0);
    vertexNormals.push(0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0);
    vertexNormals.push(-1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0, -1.0, 0.0, 0.0);
  }

  function generateVoxelPositions(i, j, k){
    var xyz = getVoxelCenter(i, j, k);
    var h =  quadsize/2;
    //Side 1
    positions.push(
        xyz.x - h, xyz.y - h, xyz.z - h,
        xyz.x + h, xyz.y - h, xyz.z - h,
        xyz.x + h, xyz.y + h, xyz.z - h,
        xyz.x - h, xyz.y + h, xyz.z - h,
    )
    //Side 2
    positions.push(
        xyz.x - h, xyz.y - h, xyz.z - h,
        xyz.x + h, xyz.y - h, xyz.z - h,
        xyz.x + h, xyz.y - h, xyz.z + h,
        xyz.x - h, xyz.y - h, xyz.z + h,
    )
    //Side 3
    positions.push(
        xyz.x - h, xyz.y - h, xyz.z - h,
        xyz.x - h, xyz.y + h, xyz.z - h,
        xyz.x - h, xyz.y + h, xyz.z + h,
        xyz.x - h, xyz.y - h, xyz.z + h,
    )
    //Side 4
    positions.push(
        xyz.x - h, xyz.y - h, xyz.z + h,
        xyz.x + h, xyz.y - h, xyz.z + h,
        xyz.x + h, xyz.y + h, xyz.z + h,
        xyz.x - h, xyz.y + h, xyz.z + h,
    )
    //Side 5
    positions.push(
        xyz.x - h, xyz.y + h, xyz.z - h,
        xyz.x + h, xyz.y + h, xyz.z - h,
        xyz.x + h, xyz.y + h, xyz.z + h,
        xyz.x - h, xyz.y + h, xyz.z + h,
    )
    //Side 6
    positions.push(
        xyz.x + h, xyz.y - h, xyz.z - h,
        xyz.x + h, xyz.y + h, xyz.z - h,
        xyz.x + h, xyz.y + h, xyz.z + h,
        xyz.x + h, xyz.y - h, xyz.z + h,
    )
  }

  function generateCubeBufferData(side){
    var ind_len =  (4 * res*res) * side;

    //Iterate over Faces
    for(var j = 0; j < res; j++) {
      for(var i = 0; i < res; i++){
        generatePositions(side,i,j);

        if(averages != null){ continue; }
        generateNormals(side);

        var v0 = 0 + (j * 4 * res) + (i * 4) + ind_len;
        var v1 = 1 + (j * 4 * res) + (i * 4) + ind_len;
        var v2 = 2 + (j * 4 * res) + (i * 4) + ind_len;
        var v3 = 3 + (j * 4 * res) + (i * 4) + ind_len;

        indices.push(
            v0, v1, v2,  //First Triangle Face
            v0, v2, v3,  //Second Triangle Face
        );
      }
    }
  }

  function generatePlaneBufferData(){
    var offs = -2;
    var ind_len =  (4 * res*res);

    var lb = getCoords(0, 0);
    var rt = getCoords(res-1, res-1);

    var l = lb.x1;
    var r = rt.x3;
    var b = lb.y1;
    var t = rt.y3;

    positions.push(l, b, (z+offs), r, b, (z+offs), r, t, (z+offs), l, t, (z+offs));
    generateNormals(0);

    var v0 = 0 + ind_len;
    var v1 = 1 + ind_len;
    var v2 = 2 + ind_len;
    var v3 = 3 + ind_len;

    indices.push(
        v0, v1, v2,  //First Triangle Face
        v0, v2, v3,  //Second Triangle Face
    );
  }


  generateCubeBufferData(0);
  if(bg){
     generatePlaneBufferData();
  }

  /*generateCubeBufferData(1);
  generateCubeBufferData(2);
  generateCubeBufferData(3);
  generateCubeBufferData(4);
  generateCubeBufferData(5);*/


  function generateCubes(){
    var verts = 0;
    for(var i= 0; i<res; i++){
      for(var j= 0; j<res; j++){
        for(var k= 0; k<res; k++){
          generateVoxelPositions(i,j,k);
          generateVoxelNormals();

          var ind_len = verts;
          //console.log(ind_len);

          var v0 = 0+ind_len;
          var v1 = 1+ind_len;
          var v2 = 2+ind_len;
          var v3 = 3+ind_len;

          indices.push(v0+(4*0), v1+(4*0), v2+(4*0), v0+(4*0), v2+(4*0), v3+(4*0)); //Side 1
          indices.push(v0+(4*1), v1+(4*1), v2+(4*1), v0+(4*1), v2+(4*1), v3+(4*1)); //Side 2
          indices.push(v0+(4*2), v1+(4*2), v2+(4*2), v0+(4*2), v2+(4*2), v3+(4*2)); //Side 3
          indices.push(v0+(4*3), v1+(4*3), v2+(4*3), v0+(4*3), v2+(4*3), v3+(4*3)); //Side 4
          indices.push(v0+(4*4), v1+(4*4), v2+(4*4), v0+(4*4), v2+(4*4), v3+(4*4)); //Side 5
          indices.push(v0+(4*5), v1+(4*5), v2+(4*5), v0+(4*5), v2+(4*5), v3+(4*5)); //Side 6

          verts += 24;
        }
      }
    }
  }


  //generateCubes();


  function initPositionBuffer() {
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    return positionBuffer;
  }

  function initColorBuffer() {
    const faceColors = [[1.0, 1.0, 1.0, 1.0]];
    var colors = [];
    for (var j = 0; j < faceColors.length; ++j) {
      const c = faceColors[j];
      // Repeat each color four times for the four vertices of the face
      colors = colors.concat(c, c, c, c);
    }
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    return colorBuffer;
  }

  function initIndexBuffer() {
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(
        gl.ELEMENT_ARRAY_BUFFER,
        new Uint16Array(indices),
        gl.STATIC_DRAW
    );
    return indexBuffer;
  }

  function initTextureBuffer() {
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array(textureCoordinates),
        gl.STATIC_DRAW
    );
    return textureCoordBuffer;
  }

  function initNormalBuffer() {
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array(vertexNormals),
        gl.STATIC_DRAW
    );
    return normalBuffer;
  }





  if(averages != null){
    const positionBuffer = initPositionBuffer();
    return positionBuffer;
  }


  const positionBuffer = initPositionBuffer();
  const textureCoordBuffer = initTextureBuffer();
  const indexBuffer = initIndexBuffer();
  const normalBuffer = initNormalBuffer();

  return {
    position: positionBuffer,
    normal: normalBuffer,
    textureCoord: textureCoordBuffer,
    indices: indexBuffer,
  };
}

export { initBuffers };
